<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <path d="M22 10 12 5 2 10l10 5 10-5Z" />
  <path d="M6 12v5c0 1 2.5 3 6 3s6-2 6-3v-5" />
</svg></template>

<script>
export default {}
</script>